import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {PASSWORD_TOKEN_PARAM_KEY} from '@emma-labs/shared/typescript';
import {first} from 'rxjs';
import {BrokerProfileService} from '../../../services/broker-profile/broker-profile.service';

export const passwordResetPageGuard = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);

  if (route.queryParams[PASSWORD_TOKEN_PARAM_KEY]) {
    const profileService = inject(BrokerProfileService);

    return profileService
      .validatePasswordToken(decodeURI(route.queryParams[PASSWORD_TOKEN_PARAM_KEY]))
      .pipe(first())
      .subscribe((isValid: boolean) => {
        return isValid ? true : router.navigate(['/', 'auth'], {queryParams: {invalidPasswordToken: true}});
      });
  } else {
    return router.navigate(['/', 'auth']);
  }
};
